import React from 'react';
import css from './SectionSchoolHero.module.css';
import { isArrayLength } from '../../../../util/genericHelpers';
import { ExternalLink } from '../../../../components';
const SchoolCustomLinks = ({ publicData }) => {
  const { customLinks = [] } = publicData || {};

  if (!isArrayLength(customLinks)) return null;

  return (
    <ul className={css.groupCustomLinks} role="navigation" aria-label="Brand Custom Links">
      {customLinks.map((link, index) => (
        <li key={link.url || index} className={css.linkItem}>
          <ExternalLink href={link.url} className={css.customLink}>
            {link.name}
          </ExternalLink>
        </li>
      ))}
    </ul>
  );
};
export default SchoolCustomLinks;
